import { useEffect, useState } from 'react';
import { Button, ButtonBack, Icon, Option } from '@/components/generic';
import { copyToClipboard, shortenAddress } from '@/utils';
import { useGetDepositInfo } from '@package/smart-wallet/hooks';

const ChangeNow = ({ onBack }: { onBack?: () => void }) => {
  const { depositAddress } = useGetDepositInfo();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    // Load the ChangeNow stepper connector script
    const script = document.createElement('script');
    script.src =
      'https://changenow.io/embeds/exchange-widget/v2/stepper-connector.js';
    script.defer = true;
    script.type = 'text/javascript';

    // Handle script load success
    script.onload = () => {
      console.log('ChangeNow stepper connector loaded successfully');
    };

    // Handle script load error
    script.onerror = () => {
      console.error('Failed to load ChangeNow stepper connector');
      setHasError(true);
    };

    // Add script to document head
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <>
      <ButtonBack title='ChangeNow' onClick={onBack} />
      <Option classTitle='w-30' title='Address' color='bg-primary-04'>
        {shortenAddress(depositAddress)}
        <button
          className='ml-auto cursor-pointer'
          type='button'
          onClick={() => copyToClipboard(depositAddress)}
        >
          <Icon name='copy' className=' !size-4  fill-t-primary' />
        </button>
      </Option>
      <div className='text-center text-xs text-t-secondary mt-2 mb-4'>
        Remember, your destination wallet, BNB Chain network, and USDT token are
        preselected by default, but just in case, you can copy them from here.
      </div>

      <div className='relative'>
        {isLoading && (
          <div className='absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded-lg'>
            <div className='text-center'>
              <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-black mx-auto mb-2'></div>
              <p className='text-sm text-t-secondary'>
                Loading ChangeNow widget...
              </p>
            </div>
          </div>
        )}

        {hasError ? (
          <div className='w-full h-[660px] bg-gray-100 rounded-lg flex items-center justify-center'>
            <div className='text-center text-t-secondary'>
              <p className='mb-2'>Failed to load ChangeNow widget</p>
              <p className='text-xs'>
                Please check your internet connection or try again later
              </p>
            </div>
          </div>
        ) : (
          <iframe
            id='iframe-widget'
            src='https://changenow.io/embeds/exchange-widget/v2/widget.html?FAQ=true&amount=500&amountFiat&backgroundColor=FFFFFF&darkMode=false&from=usdttrc20&horizontal=false&isFiat=false&lang=en-US&link_id=6f55402248e21d&locales=true&logo=false&primaryColor=000000&to=usdtbsc&toTheMoon=false'
            className='w-full h-[360px] rounded-lg border-0'
            allow='payment *; web-share *'
            sandbox='allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'
            title='ChangeNow Exchange Widget'
            loading='lazy'
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        )}
      </div>
      <Button className='w-full mt-4' isBlack onClick={onBack}>
        Close
      </Button>
    </>
  );
};

export default ChangeNow;
